<template>
  <div class="agentView-warpper">
    <nav-bar titleText="经纪人" titleWeight="bold" @goBack="goBack" :isFixed="true"></nav-bar>
    <div class="contentBox">
      <div class="contentBox-line"></div>
      <div class="contentBox-box">
        <div class="left-img">
          <img :src="!info.member_avator ? agentimg : info.member_avator" alt />
        </div>
        <div class="right">
          <div class="title">{{info.member_realname}}&nbsp;|&nbsp;级别&nbsp;{{agentLevel}}</div>
          <div class="desc">经纪人代码&nbsp;{{info.agent_code}}</div>
        </div>
        <div class="show-contract" @click="goContract">查看电子合同</div>
      </div>
      <div class="qrcode-team-box">
        <div class="qrcode" @click="goQrcode">
          <img src="../../../assets/debtor/qrCode.png" alt="">
          <span>推广码</span>
        </div>
        <div class="line"></div>
        <div class="my-team" @click="goMyTeam">
          <img src="../../../assets/debtor/myteam-icon.png" alt="">
          <span>我的团队</span>
        </div>
      </div>
      <div class="my_commissionBody">
        <van-row class="my_commission_row">
          <van-col span="18">
            <div class="my_commission">
              <p class="my_comm_title">我的可提现金额</p>
              <p class="my_comm_money">¥{{Number(info.balance).toFixed(2)}}</p>
            </div>
          </van-col>
          <van-col span="6">
            <div class="my_comm_view" @click="viewCommission()">去查看</div>
            <div class="clear_both"></div>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="agent-view-first">
      <div class="agent-contact-service" @click="chat">
        <span>遇到问题？</span>
        <span>联系客服，为您解答</span>
        <img src="../../../assets/debtor/right-arrow.png" alt="">
      </div>
      <p class="debt-order-title">解债订单</p>
      <div class="refresh-btn" @click="refreshList">
        <img :src="reloadgrayicon" alt="">
      </div>
    </div>

    <!-- <van-pull-refresh v-model="refreshing" @refresh="onRefresh"> -->
    <van-list v-model="loading" :finished="finished" :finished-text="this.list.length === 0 ? '' : '没有更多了'"
      @load="onLoad">
      <div class="lists" v-for="(item, index) in list" :key="index">
        <div class="dataBody" @click="handleAgent(item.id)">
          <div class="debtor_information">
            <div class="title">{{item.status}}</div>
            <div>
              <div class="creditorsName">{{item.debtor_name || item.debtor_company_name}}</div>
              <div class="creditorsIcon">
                <div class="process_icon">
                  <van-icon class="phase" name="play" :style="{ color: '#b3b0b0'}" />
                  <van-icon class="phase" name="play" :style="{ color: '#848181'}" />
                  <van-icon class="phase" name="play" :style="{ color: '#3a3939'}" />
                </div>
              </div>
              <div class="debtorName">{{item.creditor_name}}</div>
              <div class="clear_both"></div>
            </div>
            <p class="solutionMoney">解债金额</p>
            <p class="creditorsMoney">￥{{ item.amount }}</p>
            <p v-if="! (item.status === '订单完成' || item.status === '已完成' || item.status === '已结算' || item.status === '合同作废')"
              class="agent">预计劳务费 ¥{{item.agent_profit}}</p>
            <p v-if="item.status === '已结算' || item.status === '已完成' || item.status === '合同作废'" class="has_commission">
              劳务费 ¥{{item.agent_profit}}</p>
          </div>
        </div>
      </div>
      <div class="empty" v-if="list.length == 0" ref="agentEmpty" :style="{'padding-bottom': emptyPaddingBottom+'px'}">
        <div class="emptyMsg" span="24">
          <img src="../../../assets/debtor/empty.png" width="100%" height="100%" />
          <p class="tip">暂无解债订单</p>
        </div>
      </div>
    </van-list>
    <!-- </van-pull-refresh> -->
  </div>
</template>
<script>
  import navBar from "../components/navBar";
  export default {
    name: "agentView",
    data() {
      return {
        list: [],
        info: {},
        commissionData: {},
        agentInfo: {},
        loading: false,
        finished: false,
        refreshing: false,
        error: false,
        page: 0,
        pageSize: 10,
        emptyPaddingBottom: 0,
        agentLevel: '',
        agentimg: require('@/assets/debtor/actver.png'),
        reloadgrayicon: require('@/assets/debt/reload-gray-icon.png'),
      };
    },
    created() {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.commissionInfo();
    },
    mounted() {
      this.getEmptyPaddingBottom()
    },
    components: {
      navBar,
    },
    methods: {
      //联系客服跳原生
      chat() {
        this.showDialog = false
        this.params('18', '18', 'customerService')
      },
      getEmptyPaddingBottom() {
        const rect = this.$refs.agentEmpty.getBoundingClientRect()
        // this.emptyPaddingBottom = document.body.clientHeight - rect.bottom - 102
        this.emptyPaddingBottom = document.body.clientHeight - 543
      },
      goContract() {
        this.$router.push({
          path: '/agent/contractView',
          query: {
            agent_contract_id: this.agentInfo.agent_contract_id,
            agent_contract_url: this.info.agent_contract_url,
          },
        })
      },
      refreshList() {
        if (!this.refreshing) {
          this.refreshing = true
          this.page = 0;
          this.onLoad();
        }
      },
      onLoad() {
        this.page++;
        this.getInfo();
      },
      onRefresh() {
        this.page = 0;
        this.onLoad();
      },
      getInfo() {
        this.$api
          .post("/debt/member/agent/list", {
            page: this.page,
            size: this.pageSize,
          })
          .then((res) => {
            this.info = res;
            if (res.agent_identity == 0) {
              this.agentLevel = '普通'
            } else if (res.agent_identity == 1) {
              this.agentLevel = '主管'
            } else if (res.agent_identity == 2) {
              this.agentLevel = '经理'
            }
            const widths = res.withs.data;
            if (this.refreshing) {
              this.finished = false;
              this.list = [];
            }
            for (let i in widths) {
              widths[i].amount = widths[i].sum
              switch (widths[i].status) {
                case 10:
                  widths[i].status = "待债权人确认";
                  break;
                case 13:
                  widths[i].status = "待债务人确认";
                  break;
                case 20:
                  widths[i].status = "待债权人上传借据凭证";
                  break;
                case 23:
                  widths[i].status = "待债务人上传打款凭证";
                  break;
                case 25:
                  widths[i].status = "待平台审核";
                  break;
                case 30:
                  widths[i].status = "待财务审核";
                  break;
                case 40:
                  widths[i].status = "待合同审批";
                  break;
                case 50:
                  if (widths[i].sign_role === 0) {
                    widths[i].status = "待合同签名";
                  }
                  if (widths[i].sign_role === 1) {
                    widths[i].status = "等待债务人签署合同";
                  }
                  if (widths[i].sign_role === 2) {
                    widths[i].status = "等待债权人签署合同";
                  }
                  break;
                case 60:
                  if (widths[i].is_supplement == 1) {
                    widths[i].status = "已结算";
                  } else {
                    widths[i].status = "已结算";
                  }
                  break;
                case 70:
                  widths[i].status = "债权人驳回";
                  break;
                case 75:
                  widths[i].status = "债务人驳回";
                  break;
                case 80:
                  widths[i].status = "平台驳回";
                  break;
                case 85:
                  widths[i].status = "财务驳回";
                  break;
                case 90:
                  widths[i].status = "合同审批驳回";
                  break;
                case 100:
                  widths[i].status = "合同撤回";
                  break;
                case 110:
                  widths[i].status = "合同失效";
                  break;
                case 120:
                  if (widths[i].is_supplement == 1) {
                    widths[i].status = "已结算";
                  } else {
                    widths[i].status = "合同作废";
                  }
                  break;
                case 130:
                  widths[i].status = "已结算";
                  break;
                default:
                  widths[i].status = "订单状态异常";
              }
              this.list.push(widths[i]);
            }

            if (this.list.length === 0 || widths.length === 0) {
              this.finished = true;
              this.loading = false;
              this.refreshing = false;
              return;
            }

            this.loading = false;
            if (res.withs.current_page === res.withs.last_page) {
              this.finished = true;
            }

            if (this.refreshing) {
              this.$toast("刷新成功");
              this.refreshing = false;
            }

            if (!this.finished && !this.loading && this.list.length <= 2) {
              this.onLoad();
            }
          })
          .catch((err) => {
            this.loading = false
            this.finished = true
            let keys = Object.keys(err);
            let key = keys[0];
            let message = err.message || err[key][0];
            //this.$toast(message);
            if (message.slice(0, 10) == "timeout of") {
              this.$toast("网络不给力，请稍候重试");
            }
            return;
          });
      },
      async commissionInfo() {
        try {

          const param = {
            page: 1,
            size: 1,
          }
          this.agentInfo = await this.$api.post("debt/member/agent/list", param)
          // this.agentInfo = await this.$api.post('/debt/member/agent/status') 
          // this.commissionData = await this.$api.post("/finance/member/account/info", {
          //   id: this.agentInfo.account_id
          // })
        } catch (err) {
          console.log(err)
          this.$toast(err.message)
        }
      },
      //订单详情
      handleAgent(id) {
        this.$router.push({
          path: "/agent/detail",
          query: {
            account_id: id,
            debt_from: 'list',
          },
        });
      },
      //查看佣金
      viewCommission() {
        this.$router.push({
          path: "/agent/myCommission",
          query: {
            account_id: this.agentInfo.account_id,
            balance:Number(this.info.balance).toFixed(2)
          }
        });
      },
      goBack() {
        // this.$router.go(-1)
        this.$router.push({
          path: '/debtRelief/wrDebtPersonHome',
          query: {
            token: localStorage.getItem('_token') || this.$route.query.token,
          },
        })
      },
      goMyTeam() {
        this.$router.push('/agent/myTeam')
      },
      goQrcode() {
        this.$router.push({
          path: '/agent/agentQrcode',
          query: {
            agent_code: this.agentInfo.agent_code,
            qr_code: this.agentInfo.qr_code,
          }
        })
      }
    },
  };
</script>
<style lang="less">
  .agentView-warpper {
    .dataBody {
      color: #333333;
      width: 100%;
      background-color: #fff;
      margin-top: 12px;

      .debtor_information {
        padding: 12px 12px 15px;

        .title {
          color: #999;
          font-weight: 600;
          font-size: 16px;
          width: 100%;
          padding-bottom: 12px;
          margin-bottom: 15px;
          border-bottom: 1px solid #eeeeee;
        }

        .solutionMoney {
          margin: 12px 0;
          padding-left: 0px;
        }

        .creditorsMoney {
          font-weight: 600;
          font-size: 24px;
          padding-left: 0px;
        }

        .agent {
          color: #ccc;
          margin-top: 9px;
          font-size: 14px;
          padding-left: 0px;
        }

        .has_commission {
          color: #f9591b;
          margin: 10px 0 0;
        }
      }

      .creditorsName {
        font-size: 14px;
        line-height: 23px;
        float: left;

      }

      .debtorName {
        float: left;
        margin-left: 9px;
      }

      .creditorsIcon {
        float: left;
        margin-left: 9px;
      }

      .process_icon {
        float: left;
        margin-top: 2px;

        .phase {
          color: #b3b0b0;
          width: 8px;
          text-align: center;
          height: 10px;
          margin: 0px 0px 0 0;
        }
      }
    }

    .empty {
      margin: 64px 48px 0;

      .emptyMsg {
        text-align: center;
        width: 100%;
        height: 100%;

        .tip {
          color: #999;
          font-size: 16px;
          margin-top: 15px;
        }
      }
    }
  }

  .agent-view-first {
    position: sticky;
    top: 88px;
    background-color: #f5f6f7;
    z-index: 22;

    .refresh-btn {
      position: absolute;
      right: 12px;
      bottom: 2px;
      width: 24px;
      height: 24px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
<style lang="less" scoped>
  .agentView-warpper {
    background-color: #f5f6f7;
    min-height: 100vh;
    color: #333;
    font-size: 14px;
    position: relative;

    .lists {
      padding: 0;
      background-color: #f5f6f7;
    }

    .clear_both {
      clear: both;
    }

    .contentBox {
      background: #fff;
      padding-bottom: 21px;
      width: 100%;
      margin-top: 88px;

      .contentBox-line {
        background-color: #f5f6f7;
        height: 12px;
        width: 100%;
      }

      .qrcode-team-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: 0 12px;
        margin-bottom: 7px;

        .qrcode {
          img {
            width: 15px;
            height: 15px;
            margin-right: 8px;
          }

          span {
            height: 21px;
            font-size: 15px;
            color: #333333;
            line-height: 21px;

          }
        }

        .line {
          width: 1px;
          height: 19px;
          background: #DDDDDD;
        }

        .my-team {
          img {
            width: 20px;
            height: 15px;
            margin-right: 8px;
          }

          span {
            height: 21px;
            font-size: 15px;
            color: #333333;
            line-height: 21px;
          }
        }
      }

      .contentBox-box {
        display: flex;
        align-items: center;
        position: relative;

        .left-img {
          // display: flex;
          // align-items: center;
          width: 42px;
          height: 42px;
          margin: 21px 12px 18px;

          img {
            width: 100%;
            height: 100%;
            border-radius: 25px;
          }
        }

        .right {
          margin: 19px 0 18px;

          .title {
            height: 26px;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
          }

          .desc {
            height: 21px;
            font-size: 13px;
            color: #999999;
            line-height: 21px;
          }
        }

        .show-contract {
          height: 21px;
          font-size: 13px;
          color: #333333;
          line-height: 21px;
          position: absolute;
          top: 28px;
          right: 12px;
        }
      }

      .my_commissionBody {
        margin: 0 12px;
        border-radius: 6px;
        background-color: #f6daa0;

        .my_commission_row {
          padding: 15px 12px;
        }

        .my_comm_title {
          font-size: 14px;
          line-height: 23px;
        }

        .my_comm_money {
          font-size: 20px;
          line-height: 32px;
          font-weight: 600;
        }

        .my_comm_view {
          width: 69px;
          height: 33px;
          background: #333;
          text-align: center;
          line-height: 33px;
          border-radius: 30px;
          margin-top: 12px;
          color: #f7e0b0;
          font-size: 16px;
          float: right;
        }

      }
    }

    .agent-contact-service {
      padding: 9px 12px 12px;
      display: flex;
      align-items: center;

      :nth-of-type(1) {
        height: 22px;
        font-size: 14px;
        color: #999999;
        line-height: 22px;
      }

      :nth-of-type(2) {
        height: 22px;
        font-size: 14px;
        color: #666666;
        line-height: 22px;
        margin-right: 6px;
      }

      img {
        width: 10px;
        height: 13px !important;
      }
    }

    p {
      height: 26px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 26px;
      padding: 0 12px;
    }
  }
</style>